import { useUserSaveItem, useUserSaveType } from "@/app/layout/useUserSaves";
import PillButton from "@/app/shared/PillButton";
import { IconButton, Menu } from "@mui/material";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { SavedSearchesList } from "./SavedSearchesList";

export function SaveSearchButton({ searchPath }: { searchPath: string }) {
  const { isSaved, isDisabled, ToggleSave } = useUserSaveItem({
    type: "SEARCH",
    key: searchPath,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userSaves } = useUserSaveType("SEARCH");
  const hasUserSaves = userSaves.length > 0;
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PillButton
        sx={{
          backgroundColor: "grey.100",
        }}
        compact
        startIcon={isSaved ? <StarIcon /> : <StarBorderIcon />}
        endIcon={
          hasUserSaves && (
            <IconButton
              component="div"
              sx={{
                margin: -1,
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleOpenMenu(event);
              }}
            >
              <ArrowDropDownIcon />
            </IconButton>
          )
        }
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (isSaved) {
            handleOpenMenu(event);
          } else {
            await ToggleSave();
          }
        }}
        disabled={isDisabled}
        loading={isDisabled}
      >
        {isSaved ? "Saved" : "Save"}
      </PillButton>
      {hasUserSaves && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseMenu}
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "center",
            vertical: "top",
          }}
        >
          <SavedSearchesList searchPath={searchPath} />
        </Menu>
      )}
    </>
  );
}
